import { MRT_ColumnDef } from 'material-react-table';
import NameCellWithImage, { ChipCell } from 'components/controls/image-cell';
import { useWorkspace } from 'hooks/useWorkspace';
import { useTranslation } from 'react-i18next';
import { NESTED_PRODUCT_STATUS_COLOR } from './status';
import { useMemo } from 'react';
import { ToolTip } from 'components/controls';

export type NestedProductColumns = {
    id: string;
    name: string;
    isActive: string;
    createdAt: string;
    placeId: string;
};

export const useNestedPorductTableColumns = (): MRT_ColumnDef<NestedProductColumns>[] => {
    const { t } = useTranslation();
    const { baseWorkspaceUrl } = useWorkspace();

    return useMemo(
        () => [
            {
                accessorKey: 'name',
                header: t('TABLE_HEADERS.NAME'),
                enableColumnActions: false,
                Cell: ({ cell }) => {
                    const path = `${baseWorkspaceUrl}/nestedProduct/${cell.row.original.placeId}/edit/${cell.row.original.id}`;
                    return (
                        <ToolTip
                            disableHoverListener={cell.row.original['name'].length < 20}
                            title={cell.getValue<string>()}
                            placement="top-end"
                        >
                            <NameCellWithImage showImage={false} cell={cell} isLink path={path} target="_self" />
                        </ToolTip>
                    );
                },
                size: 200,
            },
            {
                id: 'nestedProductCategoryId',
                accessorKey: 'nestedProductCategoryName',
                header: t('TABLE_HEADERS.CATEGORY'),
                filterVariant: 'autocomplete',
                enableColumnActions: false,
                size: 150,
            },
            {
                accessorKey: 'price',
                header: t('TABLE_HEADERS.PRICE'),
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 100,
            },
            {
                accessorKey: 'discountedPrice',
                header: t('TABLE_HEADERS.DISCOUNTED_PRICE'),
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 100,
            },
            {
                accessorKey: 'isAvailable',
                header: t('TABLE_HEADERS.AVAILABILITY'),
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 150,
                Cell: ({ cell }) => (
                    <ChipCell
                        value={cell.getValue<string>()}
                        statusColorMap={NESTED_PRODUCT_STATUS_COLOR}
                        translationKey="STATUS"
                    />
                ),
            },
            {
                accessorKey: 'createdAt',
                header: t('TABLE_HEADERS.CREATION_DATE'),
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 150,
            },
        ],
        [t, baseWorkspaceUrl],
    );
};
